// import React from 'react';
import PropTypes from 'prop-types';
import Globalize from '@sprinx/globalize';
import useMessagesNormalizer from './useMessagesNormalizer';

function GlobalizeInitializator(_ref) {
  var children = _ref.children,
      cldrData = _ref.cldrData,
      locale = _ref.locale,
      messages = _ref.messages;
  Globalize.load(cldrData);
  Globalize.loadMessages(useMessagesNormalizer(messages));
  Globalize.locale(locale);
  return children;
}

GlobalizeInitializator.propTypes = {
  children: PropTypes.node,
  cldrData: PropTypes.arrayOf(PropTypes.object),
  locale: PropTypes.string.isRequired,
  messages: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)])
};
GlobalizeInitializator.defaultProps = {
  children: null
};
export default GlobalizeInitializator;